import { defineMessages } from 'react-intl';

export const clinicianTrialEndedModalMessages = defineMessages({
  title: {
    defaultMessage: 'Your free trial has ended',
    id: 'BYbCOJRkfU',
    description:
      'Title of the modal shown once a new user’s Heidi II Clinician trial has ended',
  },
  bodyMoreThanStandard: {
    defaultMessage:
      'To keep Max usage for agents, advanced templates and in-session Evidence, upgrade to Clinician Max.',
    id: 'ieRo5852h+',
    description:
      'Clinician trial ended modal body when trial usage reached the Clinician Standard limit',
  },
  bodyWithinStandard: {
    defaultMessage:
      'To keep advanced templates, in-session Evidence and access to agents, upgrade to Clinician.',
    id: '8PKuIDrtQF',
    description:
      'Clinician trial ended modal body when trial usage stayed within the Clinician Standard limit',
  },
  keepUsingClinician: {
    defaultMessage: 'Keep using Clinician',
    id: 'PVCXVpkBWC',
    description:
      'Primary button in the Clinician trial ended modal; opens the seat checkout on the recommended seat',
  },
  downgradeToFree: {
    defaultMessage: 'Downgrade to Heidi Free',
    id: 'U6zCN1MWbj',
    description:
      'Secondary button in the Clinician trial ended modal; closes it, the member stays on Heidi Free',
  },
  footnote: {
    defaultMessage:
      'Heidi Free includes unlimited Scribe and Evidence. <usageLimits>Usage limits</usageLimits> apply.',
    id: 'CQ/YKluCCZ',
    description:
      'Footnote in the Clinician trial ended modal; Usage limits links to the usage limits article',
  },
});
